import axios from "axios";
import { API_BASE_URL } from "../../../config";

export const getActiveConverstionList = async (conversationId) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/Chat/ConversationMessages`, {
            params: {
                conversationId,
            },
        });
        return response.data;
    } catch (error)
    {
        console.error("Error fetching getActiveConverstionList:", error);
        throw error;
    }
};
